import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { actions } from '../../store/dux/field-boundary-management-dux';

export function DeleteFields({ fields, close }) {
  const dispatch = useDispatch();
  const growerName = useSelector(growerSelectors.selectedName);

  return (
    <ConfirmationDialog
      title={`Delete Fields for ${growerName}?`}
      renderBody={() => (
        <Box>
          <Typography>
            Are you sure you want to delete the following fields:
          </Typography>
          <ul>
            {fields.map((field, i) => (
              <li key={i}>{field.fieldName}</li>
            ))}
          </ul>
        </Box>
      )}
      handleClose={close}
      handleConfirm={confirm}
    />
  );

  function confirm() {
    dispatch(actions.deleteFields(fields));
    close();
  }
}
